<template>
    <div id="timer">
        <div class="layer_canvas"
             v-bind:style="canvasStyle"
        >
            <span class="timeText">{{ timeLimit }}</span>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'timer',
    props: {
      'second': Number
    },
    data () {
      let timestamp = Date.now()
      return {
        timeLimit: this.second,
        endTimestamp: timestamp + (this.second * 1000),
        timer: setInterval(this.repeat, 100),
        canvasStyle: {
          animationDuration: this.second + 's',
          animationPlayState: 'running'
        },
        running: true
      }
    },
    methods: {
      repeat () {
        if (this.running) {
          let limit = this.endTimestamp - Date.now()
          if (limit > 0) {
            this.timeLimit = parseInt(limit * 0.001)
          } else {
            this.timeLimit = 0
            this.stop()
          }
        } else {
          this.stop()
        }
      },
      stop () {
        clearInterval(this.timer)
        this.canvasStyle = Object.assign({}, this.canvasStyle, {animationPlayState: 'paused'})
        this.running = false
        this.$emit('send-parent-form')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Timer.vue?273258cf